// Mock data for Foreign Travel Approvals matching the design specifications

export const INITIAL_TRAVEL_REQUESTS = [
  {
    id: "TR-2026-001",
    employeeNo: "0003596",
    serviceNo: "0003596",
    name: "Amila Bandara",
    role: "Senior Executive",
    department: "IT Department",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&auto=format&fit=crop&q=80",
    country: "Canada",
    departureDate: "02 Oct 2026",
    arrivalDate: "16 Oct 2026",
    returnDate: "16 Oct 2026",
    duration: "14 Days",
    dateRange: "02 Oct 2026 - 16 Oct 2026",
    status: "Pending",
    purpose: "Official visit for procurement meetings and training.",
    financialDetails: {
      allowanceUSD: "2,500",
      allowanceLKR: "750,000",
      airTicketLKR: "300,000",
      visaFeesLKR: "45,000",
      othersLKR: "25,000"
    },
    attachments: [
      { id: "att-1", name: "Passport.pdf", type: "pdf", size: "2.4 MB" },
      { id: "att-2", name: "Approval Letter.jpg", type: "image", size: "1.2 MB" },
      { id: "att-3", name: "Air Ticket.pdf", type: "pdf", size: "850 KB" }
    ],
    comments: "",
    history: [
      {
        step: "Request Submitted",
        date: "01 Oct 2026 10:15 AM",
        by: "Amila Bandara",
        note: "Initial request submitted",
        status: "completed"
      },
      {
        step: "Manager Approval",
        date: "01 Oct 2026 02:30 PM",
        by: "Nadee Perera",
        note: "Approved",
        status: "completed"
      },
      {
        step: "Director Approval",
        date: "Pending",
        by: "Director",
        note: "Waiting for director approval",
        status: "pending"
      },
      {
        step: "Completed",
        date: "-",
        by: "-",
        note: "Request will be completed after final approval",
        status: "upcoming"
      }
    ]
  },
  {
    id: "TR-2026-002",
    employeeNo: "0003597",
    name: "Nadee Perera",
    role: "Assistant Manager",
    department: "HR Department",
    avatar: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&auto=format&fit=crop&q=80",
    country: "Japan",
    departureDate: "05 Oct 2026",
    returnDate: "11 Oct 2026",
    duration: "7 Days",
    dateRange: "05 Oct 2026 - 11 Oct 2026",
    status: "Pending",
    purpose: "HR International Summit and bilateral talent development training.",
    attachments: [
      { id: "att-4", name: "Passport.pdf", type: "pdf", size: "2.1 MB" },
      { id: "att-5", name: "Visa Copy.pdf", type: "pdf", size: "1.5 MB" },
      { id: "att-6", name: "Invitation Letter.pdf", type: "pdf", size: "780 KB" }
    ],
    comments: "",
    history: [
      {
        step: "Request Submitted",
        date: "02 Oct 2026 09:30 AM",
        by: "Nadee Perera",
        note: "Initial request submitted",
        status: "completed"
      },
      {
        step: "Manager Approval",
        date: "03 Oct 2026 11:45 AM",
        by: "Kasun Silva",
        note: "Endorsed for HR conference",
        status: "completed"
      },
      {
        step: "Director Approval",
        date: "Pending",
        by: "Director",
        note: "Waiting for director approval",
        status: "pending"
      },
      {
        step: "Completed",
        date: "-",
        by: "-",
        note: "Request will be completed after final approval",
        status: "upcoming"
      }
    ]
  },
  {
    id: "TR-2026-003",
    employeeNo: "0003598",
    name: "Kasun Silva",
    role: "Lead Marine Engineer",
    department: "Ship Repair Division",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&auto=format&fit=crop&q=80",
    country: "Australia",
    departureDate: "10 Nov 2026",
    returnDate: "20 Nov 2026",
    duration: "11 Days",
    dateRange: "10 Nov 2026 - 20 Nov 2026",
    status: "Pending",
    purpose: "Drydocking consultation and specialized technical inspection on client vessels.",
    attachments: [
      { id: "att-7", name: "Passport.pdf", type: "pdf", size: "2.6 MB" },
      { id: "att-8", name: "Work Permit.pdf", type: "pdf", size: "1.8 MB" },
      { id: "att-9", name: "Air Ticket.pdf", type: "pdf", size: "920 KB" }
    ],
    comments: "",
    history: [
      {
        step: "Request Submitted",
        date: "03 Oct 2026 04:00 PM",
        by: "Kasun Silva",
        note: "Initial request submitted",
        status: "completed"
      },
      {
        step: "Manager Approval",
        date: "04 Oct 2026 09:15 AM",
        by: "Department Head",
        note: "Approved by Technical Manager",
        status: "completed"
      },
      {
        step: "Director Approval",
        date: "Pending",
        by: "Director",
        note: "Waiting for director approval",
        status: "pending"
      },
      {
        step: "Completed",
        date: "-",
        by: "-",
        note: "Request will be completed after final approval",
        status: "upcoming"
      }
    ]
  },
  {
    id: "TR-2026-004",
    employeeNo: "0003599",
    name: "Tharushi Fernando",
    role: "Senior Procurement Specialist",
    department: "Supply Chain",
    avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&auto=format&fit=crop&q=80",
    country: "Singapore",
    departureDate: "15 Nov 2026",
    returnDate: "21 Nov 2026",
    duration: "7 Days",
    dateRange: "15 Nov 2026 - 21 Nov 2026",
    status: "Pending",
    purpose: "Supplier equipment audit and maritime spare parts procurement negotiations.",
    attachments: [
      { id: "att-10", name: "Passport.pdf", type: "pdf", size: "2.3 MB" },
      { id: "att-11", name: "Hotel Booking.pdf", type: "pdf", size: "1.1 MB" },
      { id: "att-12", name: "Air Ticket.pdf", type: "pdf", size: "860 KB" }
    ],
    comments: "",
    history: [
      {
        step: "Request Submitted",
        date: "04 Oct 2026 11:20 AM",
        by: "Tharushi Fernando",
        note: "Initial request submitted",
        status: "completed"
      },
      {
        step: "Manager Approval",
        date: "04 Oct 2026 03:40 PM",
        by: "Procurement Head",
        note: "Approved",
        status: "completed"
      },
      {
        step: "Director Approval",
        date: "Pending",
        by: "Director",
        note: "Waiting for director approval",
        status: "pending"
      },
      {
        step: "Completed",
        date: "-",
        by: "-",
        note: "Request will be completed after final approval",
        status: "upcoming"
      }
    ]
  },
  {
    id: "TR-2026-005",
    employeeNo: "0003601",
    name: "Dilan Jayawardena",
    role: "Electrical Superintendent",
    department: "Heavy Engineering",
    avatar: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=150&auto=format&fit=crop&q=80",
    country: "South Korea",
    departureDate: "22 Nov 2026",
    returnDate: "30 Nov 2026",
    duration: "9 Days",
    dateRange: "22 Nov 2026 - 30 Nov 2026",
    status: "Pending",
    purpose: "Shipyard crane automation and PLC commissioning training session.",
    attachments: [
      { id: "att-13", name: "Passport.pdf", type: "pdf", size: "2.2 MB" },
      { id: "att-14", name: "Invitation Letter.pdf", type: "pdf", size: "1.3 MB" }
    ],
    comments: "",
    history: [
      {
        step: "Request Submitted",
        date: "05 Oct 2026 08:30 AM",
        by: "Dilan Jayawardena",
        note: "Initial request submitted",
        status: "completed"
      },
      {
        step: "Manager Approval",
        date: "05 Oct 2026 01:10 PM",
        by: "Chief Engineer",
        note: "Approved",
        status: "completed"
      },
      {
        step: "Director Approval",
        date: "Pending",
        by: "Director",
        note: "Waiting for director approval",
        status: "pending"
      },
      {
        step: "Completed",
        date: "-",
        by: "-",
        note: "Request will be completed after final approval",
        status: "upcoming"
      }
    ]
  },
  {
    id: "TR-2026-006",
    employeeNo: "0003605",
    name: "Pradeep Weerasinghe",
    role: "Naval Architect",
    department: "Ship Building Division",
    avatar: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=150&auto=format&fit=crop&q=80",
    country: "Germany",
    departureDate: "12 Aug 2026",
    returnDate: "24 Aug 2026",
    duration: "13 Days",
    dateRange: "12 Aug 2026 - 24 Aug 2026",
    status: "Approved",
    purpose: "Hull structural analysis workshop with DNV classification society.",
    attachments: [
      { id: "att-15", name: "Passport.pdf", type: "pdf", size: "2.4 MB" },
      { id: "att-16", name: "Approval Letter.jpg", type: "image", size: "1.4 MB" },
      { id: "att-17", name: "Air Ticket.pdf", type: "pdf", size: "890 KB" }
    ],
    comments: "Approved. Ensure all DNV classification certificates are archived upon return.",
    history: [
      {
        step: "Request Submitted",
        date: "10 Jul 2026 09:00 AM",
        by: "Pradeep Weerasinghe",
        note: "Initial request submitted",
        status: "completed"
      },
      {
        step: "Manager Approval",
        date: "11 Jul 2026 11:30 AM",
        by: "Technical Director",
        note: "Endorsed",
        status: "completed"
      },
      {
        step: "Director Approval",
        date: "12 Jul 2026 02:45 PM",
        by: "Managing Director",
        note: "Approved",
        status: "completed"
      },
      {
        step: "Completed",
        date: "12 Jul 2026 03:00 PM",
        by: "HR Operations",
        note: "Travel documentation fully processed",
        status: "completed"
      }
    ]
  },
  {
    id: "TR-2026-007",
    employeeNo: "0003610",
    name: "Kavinda Rathnayake",
    role: "Safety & Quality Inspector",
    department: "HSE Department",
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&auto=format&fit=crop&q=80",
    country: "United Arab Emirates",
    departureDate: "18 Jul 2026",
    returnDate: "25 Jul 2026",
    duration: "8 Days",
    dateRange: "18 Jul 2026 - 25 Jul 2026",
    status: "Approved",
    purpose: "Offshore safety audit for client offshore platforms.",
    attachments: [
      { id: "att-18", name: "Passport.pdf", type: "pdf", size: "2.0 MB" },
      { id: "att-19", name: "Air Ticket.pdf", type: "pdf", size: "820 KB" }
    ],
    comments: "Approved by management.",
    history: [
      {
        step: "Request Submitted",
        date: "01 Jul 2026 10:00 AM",
        by: "Kavinda Rathnayake",
        note: "Initial request submitted",
        status: "completed"
      },
      {
        step: "Manager Approval",
        date: "02 Jul 2026 03:15 PM",
        by: "HSE Head",
        note: "Endorsed",
        status: "completed"
      },
      {
        step: "Director Approval",
        date: "03 Jul 2026 10:30 AM",
        by: "Director",
        note: "Approved",
        status: "completed"
      },
      {
        step: "Completed",
        date: "03 Jul 2026 11:00 AM",
        by: "HR",
        note: "Processed",
        status: "completed"
      }
    ]
  },
  {
    id: "TR-2026-008",
    employeeNo: "0003554",
    name: "Shamal Wickramasinghe",
    role: "Dockyard Operations Officer",
    department: "Yard Operations",
    avatar: "https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?w=150&auto=format&fit=crop&q=80",
    country: "United Kingdom",
    departureDate: "04 Sep 2026",
    returnDate: "10 Sep 2026",
    duration: "7 Days",
    dateRange: "04 Sep 2026 - 10 Sep 2026",
    status: "Rejected",
    purpose: "Maritime machinery exhibition attendance and client networking.",
    attachments: [
      { id: "att-20", name: "Passport.pdf", type: "pdf", size: "2.5 MB" },
      { id: "att-21", name: "Exhibition Pass.pdf", type: "pdf", size: "1.1 MB" }
    ],
    comments: "Travel budget for Q3 international conferences has been exhausted. Please re-submit in Q4.",
    history: [
      {
        step: "Request Submitted",
        date: "15 Aug 2026 11:00 AM",
        by: "Shamal Wickramasinghe",
        note: "Initial request submitted",
        status: "completed"
      },
      {
        step: "Manager Approval",
        date: "16 Aug 2026 02:00 PM",
        by: "Operations Manager",
        note: "Endorsed",
        status: "completed"
      },
      {
        step: "Director Approval",
        date: "18 Aug 2026 04:30 PM",
        by: "Finance & Operations Director",
        note: "Rejected - Q3 budget limit exceeded",
        status: "rejected"
      },
      {
        step: "Completed",
        date: "18 Aug 2026 04:35 PM",
        by: "System",
        note: "Request closed as rejected",
        status: "completed"
      }
    ]
  }
];
